import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { Link as RouterLink } from "react-router-dom";

import AppHeader from "../components/app-header.component";
import { displayFontFamily } from "../theme/mtgTheme";

const DecksPage: FC = () => {
  return (
    <Box sx={{ minHeight: "100vh", pb: 6 }}>
      <AppHeader />

      <Container maxWidth="xl" sx={{ py: { xs: 3, md: 4 } }}>
        <Stack spacing={3}>
          <Card>
            <CardContent sx={{ p: { xs: 3, md: 4 } }}>
              <Stack spacing={2.5} alignItems="flex-start">
                <Stack
                  direction={{ xs: "column", lg: "row" }}
                  spacing={3}
                  justifyContent="space-between"
                  alignItems={{ lg: "center" }}
                  sx={{ width: "100%" }}
                >
                  <Box>
                    <Typography variant="h3">Decks</Typography>
                    <Typography
                      color="text.secondary"
                      sx={{
                        mt: 1.5,
                        maxWidth: 720,
                        fontFamily: displayFontFamily,
                        fontSize: "0.95rem",
                      }}
                    >
                      Turn Bulk Into Battle-Ready Decks
                    </Typography>
                  </Box>

                  <Button component={RouterLink} to="/decks/new">
                    Create new deck
                  </Button>
                </Stack>

                <Typography color="text.secondary">
                  No decks yet. Create a new deck to start defining a list.
                </Typography>
                <Alert severity="info" sx={{ width: "100%" }}>
                  Deck persistence is not wired up yet. This page is the
                  frontend shell for the upcoming deck workflow.
                </Alert>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
};

export default DecksPage;
